"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCashBalancesFeedContextArtifacts = exports.createCashBalancesFeedContext = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("./utils"));
const { cloneDeep, includes, remove } = lodash_1.default;
const createCashBalancesFeedContext = (manualBankAccountReport) => {
    (0, common_1.finleyAssert)(manualBankAccountReport.creditFacilitySlug, 'creditFacilitySlug of manualBankAccountReport type must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'cashBalancesFeedContext',
        configuration: {},
        loanProductSlug: null,
        creditFacilitySlug: manualBankAccountReport.creditFacilitySlug,
        artifactDocumentId: manualBankAccountReport.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `cashBalancesFeedContext_${manualBankAccountReport.creditFacilitySlug}`, // uniq for cashBalancesFeedContext
    };
};
exports.createCashBalancesFeedContext = createCashBalancesFeedContext;
const addCashBalancesFeedContextArtifacts = (graph) => {
    const dataTapeDependencies = cloneDeep(graph.dataTapeDependencies);
    const dataTapes = cloneDeep(graph.dataTapes);
    const manualBankAccountReports = utils.filterManualBankAccountReports({
        dataTapes,
    });
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const borrowingBaseReportIds = (0, remeda_1.map)(borrowingBaseReports, ({ id }) => id);
    (0, remeda_1.forEach)(manualBankAccountReports, (manualBankAccountReport) => {
        const cashBalancesFeedContext = (0, exports.createCashBalancesFeedContext)(manualBankAccountReport);
        // remove edge from ManualBankAccountReport => BorrowingBaseReport
        const removedDependencies = remove(dataTapeDependencies, (dep) => includes(borrowingBaseReportIds, dep.outputArtifactId) &&
            dep.inputArtifactId === manualBankAccountReport.id);
        (0, common_1.finleyAssert)(removedDependencies.length === 1, 'manualBankAccountReport should be associated with only 1 borrowing base report');
        const { outputDependency } = utils.insertDependency({
            dataTapeDependency: removedDependencies[0],
            insertId: cashBalancesFeedContext.id,
        });
        // we don't want to add inputDependency here (manualBankAccountReport => cashBalancesFeedContext)
        // as bank report lambda will create leaf node cashBalanceFeed once all required
        // cash balances have been uploaded.
        dataTapeDependencies.push(outputDependency);
        dataTapes.push(cashBalancesFeedContext);
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addCashBalancesFeedContextArtifacts = addCashBalancesFeedContextArtifacts;
//# sourceMappingURL=cashBalancesFeedContext.js.map